import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ to, label = "Back" }) {
  const navigate = useNavigate();
  const go = () => {
    if (to) navigate(to);
    else if (window.history.length > 1) navigate(-1);
    else navigate("/");
  };
  return (
    <Button variant="ghost" size="sm" onClick={go} className="mb-2 -ml-2 text-muted-foreground hover:text-foreground" data-testid="back-btn">
      <ArrowLeft className="w-4 h-4 mr-1" /> {label}
    </Button>
  );
}
